import Modal, { ModalHTMLElement } from './modal';

export default function openWhitePaperWithHash() : void {
    document.querySelectorAll<HTMLAnchorElement>('[href^="#white-paper-modal-"]').forEach($toggler => {
        const modalName = $toggler.getAttribute('href')?.replace('#white-paper-modal-', '');
        if (!modalName) {
            return;
        }

        const $modal = document.querySelector<ModalHTMLElement>(`#${modalName}`);
        if (!$modal) {
            return;
        }

        $toggler.addEventListener('click', evt => {
            evt.preventDefault();
            Modal.openModal($modal);
        });
    });

    // TODO: À supprimer. Ajouté temporairement pour supporter l'ancienne config (sprint 2) (voir également white-paper.php)
    const $toggler = document.querySelector<HTMLAnchorElement>('[href="#toggle-white-paper"]');
    if ($toggler) {
        const $modal = document.querySelector<ModalHTMLElement>('#white-paper');
        if ($modal) {
            $toggler.addEventListener('click', evt => {
                evt.preventDefault();
                Modal.openModal($modal);
            });
        }
    }
}
